import axios from "axios";
import store from "../store";
import state from "@/store";

const baseURL = store.getters.mainAppURL + "orders/";
const getRestaurantCancelledOrders = (params) => axios.post(baseURL +"get_restaurant_cancelled_orders", params);
const getOrderDetailsByCallerNumber = (caller_number) => axios.post(baseURL + "get_order_by_caller_number/" + caller_number);

const exportOrders = (params) => axios.post(store.getters.mainAppURL + "export_orders", params );
const getOrderPaymentStatuses = () => axios.get(state.getters.mainAppURL + "orders/get_all_payment_statuses");
const updateOrder = (params) => axios.post(baseURL +"edit", params);

const updateCustomDeliveryFee = (params) => axios.post(baseURL + "update_order_custom_delivery_fee", params);

export {
    getRestaurantCancelledOrders,
    getOrderDetailsByCallerNumber,
    getOrderPaymentStatuses,
    exportOrders,
    updateCustomDeliveryFee,
    updateOrder
}


